// extracted by mini-css-extract-plugin
export default {"popper":"user-tooltip_popper__quQv9"};